import React from 'react';
import { ApolloError } from '@apollo/client';
import { Card, CardContent, Grid } from '@mui/material';

import { Typography, CircularProgress, LinearProgress, InfoField } from '@occc/ui-design-system';
import { ProductCategoryFragment } from '@occc/graphql';

interface ProductCategoryDetailsProps {
  loading: boolean;
  error?: ApolloError;
  productCategory?: ProductCategoryFragment | null;
}

export const ProductCategoryDetails: React.FC<ProductCategoryDetailsProps> = ({
  loading,
  error,
  productCategory,
}) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }

  if (loading && !productCategory) {
    return <CircularProgress />;
  }

  if (!productCategory) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent>
        <Typography variant='h6'>General Details</Typography>
        <Grid container spacing={3} pt={3}>
          <Grid item xs={12} md={4}>
            <InfoField label='Name' value={productCategory.name} mb={0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfoField label='Restriction' value={productCategory.categoryRestriction} mb={0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfoField label='Rank' value={productCategory.rank} mb={0} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
